import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  section: css`
    padding: 0px 16px;
    @media (max-width: 800px) {
      padding: 0px 8px;
    }
  `,
  container: css`
    flex: 1 1 auto;
    display: flex;
    flex-flow: column nowrap;
    width: 100%;
    flex-grow: 10;
  `,
  endMessage: css`
    display: flex;
    justify-content: center;
    margin-top: 100px;
    margin-bottom: 20px;
  `,
  tooltipButton: css`
    padding-left: 4px;
    & .MuiIconButton-root {
      color: ${colors.slate};
      padding: 4px;
      border: 1px solid transparent;
    }
    & .MuiIconButton-root:hover {
      background-color: ${colors.silver};
      border: 1px solid ${colors.stone};
    }
  `,
  communityHeader: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 16px;
  `,
  viewAllFlyersContainer: css`
    padding: 16px 0px 48px 0px;
    display: flex;
    justify-content: center;
  `,
  buttonGrid: css`
    display: flex;
    margin-left: auto;
  `,
};

export default styles;
